import { render, staticRenderFns } from "./SpecialPage.vue?vue&type=template&id=249c7e9d"
import script from "./SpecialPage.vue?vue&type=script&lang=js"
export * from "./SpecialPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports